// @ts-nocheck

import { useAtomValue } from 'jotai';

import React from 'react';
import cn from 'classnames';
import { Col, Row, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import styles from '../styles/MoreAboutTheCompany.module.css';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { isVariationV3Route } from '@shared/utils';
import { LogService } from '@shared/services/LogService';

export const MoreAboutTheCompany = ({ tabIndex, moreAboutUsConfig = {} }) => {
  const { hide } = moreAboutUsConfig;
  const { t } = useTranslation();
  const language = useAtomValue(languageAtom);
  const dcb = useAtomValue(dcbAtom);
  const isV3Route = isVariationV3Route(dcb.variationKey);

  if (hide) {
    return null;
  }

  const handleLinkClick = (link, eventName) => {
    LogService.handleEvent(eventName);
    let anchor = document.createElement('a');
    anchor.href = link;
    anchor.target = '_blank';
    anchor.click();
  };

  return (
    <>
      <Row className={cn('mt-4', isV3Route && styles.rowMarginBottom)}>
        <Col>
          <p className="section-title-1 fs-10">{t('more_about_company')}</p>
        </Col>
      </Row>

      <Container className={cn('container-sm', isV3Route && 'px-4')}>
        <Row className="mt-1">
          <Col xs={6}>
            <button
              className={styles['company-link']}
              onClick={() =>
                handleLinkClick('https://360vuz.com/', 'main_click_button_main_website')
              }
              tabIndex={tabIndex}
            >
              {t('main_website')}
            </button>
          </Col>

          <Col xs={6}>
            <button
              className={styles['company-link']}
              onClick={() =>
                handleLinkClick(
                  isV3Route && language?.locale === 'ar'
                    ? 'https://vuz.com/ar/privacy-policy'
                    : 'https://360vuz.com/360VUZPlatformPolicy.html',
                  'main_click_button_privacy_policy'
                )
              }
              tabIndex={tabIndex}
            >
              {t('privacy_policy')}
            </button>
          </Col>

          <Col xs={6}>
            <button
              className={styles['company-link']}
              onClick={() =>
                handleLinkClick(
                  isV3Route && language?.locale === 'ar'
                    ? 'https://vuz.com/ar/terms-conditions'
                    : 'https://360vuz.com/TermsConditionsPrivacyPolicy.html',
                  'main_click_button_terms_and_conditions'
                )
              }
              tabIndex={tabIndex}
            >
              {t('terms_and_conditions')}
            </button>
          </Col>

          <Col xs={6}>
            <button
              className={styles['company-link']}
              onClick={() =>
                handleLinkClick(
                  'https://360vuz.com/360VUZCommunityGuidelines.html',
                  'main_click_button_community_guidelines'
                )
              }
              tabIndex={tabIndex}
            >
              {t('community_guidelines')}
            </button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
